interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | "dots")[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | "dots")[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("dots");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("dots");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(current, totalPages);

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-s-line text-base" />
        </span>
        上一页
      </button>
      {pages.map((page, index) =>
        page === "dots" ? (
          <span key={`dots-${index}`} className="px-1 text-sm text-foreground-400">
            ···
          </span>
        ) : (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            aria-current={page === current ? "page" : undefined}
            className={`h-9 w-9 cursor-pointer rounded-md text-sm transition-colors ${
              page === current
                ? "bg-primary-500 font-medium text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {page}
          </button>
        )
      )}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, current + 1))}
        disabled={current === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        下一页
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-right-s-line text-base" />
        </span>
      </button>
    </nav>
  );
}